// import { colorInput, inputFontSize, defaultColor, mediumScreen, smallScreen, largeScreen } from 'common/theme'
import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'

export const StyledGroundingOptions = styled.div`
  --padding-content: 3rem;
  --padding-content-mobile: 2rem;

  .dropdown:focus,
  .dropdown:focus-visible,
  .dropdown:hover {
    box-shadow: none;
  }

  .dropdown-menu {
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
  }

  .dropdown-item.active,
  .dropdown-item:focus-visible,
  .dropdown-item:hover {
    outline: 0;
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    color: #fff;
  }

  input:focus {
    border-color: ${({ theme }) => {
      return theme.carousel.buttonBorder
    }}!important;
    outline: 0;
    box-shadow: ${({ theme }) => {
      return '0 0 0 0' + theme.carousel.buttonBorder
    }}!important;
  }
  .option-confirm {
    p:first-child {
      font-size: 15px;
      font-weight: 600;
    }

    .pull-ahead {
      display: block;
      .has-error {
        font-weight: bold;
        font-size: 13px;
        color: #a94442;
      }
      .program-info-desc {
        margin-left: 25px;
        font-size: 13px;
      }
      .program-info {
        margin-left: 25px;
        font-size: 13px;
        margin-top: 10px;
      }
    }

    .option {
      margin-top: 10px;
    }

    div {
      display: flex;
      align-items: start;

      input {
        min-width: 16px;
        min-height: 25px;
        margin-right: 10px;
        cursor: pointer;
      }

      label {
        vertical-align: bottom;
        margin-bottom: 0.3rem;
        /* font-weight: normal; */
        cursor: pointer;
        transform: translateY(3px);
      }
    }
  }

  .indication-row {
    margin-top: 10px;
  }

  .indication-row {
    margin-top: 10px;
    margin-bottom: 5px;

    .indication-radio {
      display: flex;
      align-items: center;

      .radio-button {
        transform: translateY(0px);
      }
    }
  }

  .radio-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    transform: translateY(5px);
  }

  .radio-button input[type='radio'] {
    display: none;
  }

  .radio-checkmark {
    display: inline-block;
    position: relative;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    border: 1px solid #333;
    border-radius: 50%;
  }

  .radio-checkmark:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #333;
    transition: all 0.2s ease-in-out;
  }

  .radio-button input[type='radio']:checked ~ .radio-checkmark:before {
    transform: translate(-50%, -50%) scale(1);
  }

  form {
    padding: 20px var(--padding-content);
    border-radius: 3px;
    box-shadow: 0px -1px 2px rgb(0 0 0 / 15%), 2px 2px 2px rgb(0 0 0 / 25%);
    margin: 5px 0 30px 0;
    display: block;
    background-color: white;

    > p:first-child {
      text-align: end;
      font-weight: 600;
      font-size: 16px;
      margin-bottom: -12px;
    }
  }

  .error-label {
    min-height: 1.8rem;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 1.2rem !important;
    margin-bottom: 0;
    margin-top: 8px;
    font-weight: bold;
  }

  .required-field:after {
    content: '*';
    color: ${({ theme }) => theme.colors.primary};
    margin-left: 0.2rem;
  }

  button {
    margin-left: 0;
  }

  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-1,
  .col-md-6,
  .col-md-5,
  .col-md-1,
  .col-sm-4,
  .col-lg-12 {
    padding: 0;
  }

  .row {
    margin-right: 0;
    margin-left: 0;
  }

  .text-divider {
    padding: 0;
    margin-top: 15px;
    text-transform: uppercase;

    h2 {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
    }

    :first-child {
      margin-top: 0;
    }
  }

  .right-field,
  .left-field {
    label {
      font-weight: 600;
    }

    .col-lg-6 {
      padding: 0;
    }
  }

  .alert {
    max-width: 100% !important;
  }

  .left-field {
    padding-right: calc(var(--padding-content) / 2);
  }

  .right-field {
    padding-left: calc(var(--padding-content) / 2);
    margin-top: 1rem;
  }

  .dropdown-container {
    height: 30px;
  }

  .actual-mileage-warning {
    min-height: 1.8rem;
    line-height: 1.8rem;
    font-size: 15px;
    color: red;
    margin-bottom: 0;
  }

  .odometer-input {
    margin-top: 16px;
    margin-bottom: 10px;
  }

  .odometer-warning {
    margin-bottom: 10px;
    p:before {
      content: '! ';
    }

    .odometer-warning-label {
      font-size: 15px;
      color: red;
      text-align: end;
      margin: 0;
    }

    .form-check {
      text-align: end;

      input {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }

      label {
        cursor: pointer;
        font-weight: normal;
      }
    }
  }
`

export const StyledGroundingOption = styled.div`
  .campaign-title {
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    margin-bottom: 20px;
  }

  .disposition-title {
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    margin-bottom: 20px;
    margin-top: 32px;
  }

  .grounding-data-option {
    display: flex;
    position: relative;
    align-items: start;
    margin-bottom: 1rem;
    margin-top: 1rem;
    width: 100%;
    /* 
    input[type='radio']:after {
      width: 15px;
      height: 15px;
      border-radius: 15px;
      top: -2px;
      left: -1px;
      position: relative;
      background-color: #d1d3d1;
      content: '';
      display: inline-block;
      visibility: visible;
      border: 2px solid white;
    } */

    .purchase-content {
      transform: translateY(3px);

      .purchase-price {
        margin-bottom: 4px;
        font-weight: bold;
        line-height: 1.5;
        font-size: 14px;
      }
    }

    input {
      min-width: 16px;
      min-height: 25px;
      margin-right: 10px;
      cursor: pointer;
    }

    label {
      white-space: nowrap;
      vertical-align: bottom;
      margin-bottom: 0.3rem;
      font-weight: normal;
      cursor: pointer;
    }

    &:not(:last-child) {
      padding-right: 5%;
    }
  }

  .date-picker {
    display: flex;
    align-items: center;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  .date-label {
    transform: translateY(-1rem);
  }

  .date-input {
    /* transform: translateY(1rem); */
    margin-left: 3rem;
  }
  a {
    color: ${({ theme }) => theme.colors.InfinitiLinkColor};
    :hover {
      color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor};
    }
  }
`

export const StyledGroundingOdometer = styled.div`
  .col-lg-6:last-child {
    padding-right: 0;
    padding-right: 0;
  }

  .odometer-input {
    input {
      max-width: 380px;
    }
  }
`

export const StyledGroundingItem = styled.div`
  button {
    margin-top: 0;
  }

  .grounding-item {
    span {
      margin-bottom: 0.5rem;
      font-weight: bold;
      display: flex;
    }
  }

  .grounding-item-container {
    width: 100%;
  }

  .grounding-item-container > .text-divider {
    padding-right: calc(var(--padding-content) / 2);
  }

  .grounding-contact-container > .text-divider {
    padding-left: calc(var(--padding-content) / 2);
  }
`

export const StyledGroundingAdditional = styled.div`
  display: inline-block;
  width: 100%;

  textarea {
    font-size: 14px;
    resize: none;
  }

  .dropdown span {
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .grounding-notice {
    margin-top: 30px;
    margin-left: -20px;
  }

  .addition-groups-button {
    display: flex;
    flex-wrap: nowrap;

    > div {
      /* width: 50%; */
      text-align: end;
    }

    .btn.btn-link {
      padding: 0.3rem;
    }
    svg:hover {
      opacity: 0.5;
    }
  }

  .col-lg-1 {
    text-align: end;
  }
  #termsLink {
    color: ${({ theme }) => theme.colors.InfinitiLinkColor};
    :hover {
      color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor};
    }
  }
  .btn-link {
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }
`

export const StyledGroundingReview = styled.div`
  display: block;
  text-align: end;
  margin-top: 20px;
  margin-bottom: 15px;
  .btn-link {
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    :hover {
      color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor};
    }
  }
`

export const StyledVehicleDetailDivider = styled.div`
  align-items: center;
  cursor: pointer;
  padding: 8px 0;

  label {
    white-space: nowrap;
  }
`

export const StyledDatePickerWithIcon = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ced4da;
  border-radius: 0.4rem;
  background: #ffffff;
  max-width: 160px;
  .dateInput {
    width: 100%;
    height: 100%;
  }
  .dateInput input {
    cursor: default;
    border: none;
    width: calc(100% + 2.5rem);
    background: transparent;
  }
  .react-datepicker__day {
    &--selected,
    &--in-range,
    &--keyboard-selected {
      background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    }
  }
  svg {
    width: 2.5rem;
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }
`

export const StyledLabelRequired = styled.span`
  font-weight: bolder;
  display: flex;
  ::after {
    content: '*';
    color: ${({ theme }) => theme.colors.primary};
  }
`
